import React from "react";
import {
  paragraphStyle,
  headingStyle,
  paragraphStyleUL,
  paragraphStyleOL,
} from "../../../calculatorStyleData";
import tongueOut from "../../../../Assets/Images/tongue-out.webp";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

const StepOne = () => {
  return (
    <>
      <div>
        <section>
          <h2 style={headingStyle} className="mt-3">
            What is the Repo Rate Based EMI Calculator?
          </h2>
          <p style={paragraphStyle}>
            The Repo Rate Based EMI Calculator helps you instantly estimate how
            your monthly EMI would change if the Reserve Bank of India (RBI)
            modifies the repo rate — either upwards or downwards.
          </p>
          <p style={paragraphStyle}>
            This tool is designed for all types of repo-linked loans like home
            loans, personal loans, car loans, and loan against property,
            applicable across all banks and NBFCs.
          </p>
          <p style={paragraphStyle} className="font-bold">
            Simply enter your:
          </p>
          <ul style={paragraphStyleUL}>
            <li>Loan Amount</li>
            <li>Current Interest Rate</li>
            <li>Loan Tenure</li>
          </ul>
          <p style={paragraphStyle} className="font-bold">
            And quickly view:
          </p>
          <ul style={paragraphStyleUL}>
            <li>Your New EMI after repo rate change</li>
            <li>Your Monthly Savings or Additional Outflow</li>
          </ul>
        </section>
        <section>
          <h2 style={headingStyle}>
            Why Should You Use the Repo Rate Based EMI Calculator?
          </h2>
          <p style={paragraphStyle} className="font-bold">
            Understanding repo rate impacts allows you to:
          </p>
          <ul style={paragraphStyleUL}>
            <li>Plan your EMI repayments proactively</li>
            <li>Optimize your refinancing or balance transfer timing</li>
            <li>Negotiate better rates when repo rates fall</li>
            <li>Prepare for higher EMIs if rates rise</li>
            <li>Strategically manage loan prepayments and tenure</li>
          </ul>

          <div className="tips mt-2 ">
            <div id="border_line"></div>
            <div id="tip__container" className="px-2 px-sm-4 py-4">
              <div className="px-3 py-2">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <img
                    src={tongueOut}
                    alt=""
                    style={{ width: 30, height: 30 }}
                  />
                  <Typography
                    sx={{
                      fontSize: 16,
                      lineHeight: "24px",
                      letterSpacing: "0.08px",
                      color: "#59266D",
                      // color: "yellow",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    MinEmi Tip:
                  </Typography>
                </div>
                <div className="mt-2">
                  <Typography
                    sx={{
                      fontSize: 16,
                      lineHeight: "24px",
                      letterSpacing: "0.08px",
                      fontWeight: 500,
                      color: "#1F1F1F",

                      fontFamily: "'Archivo', sans-serif",
                    }}
                  >
                    Even a small 0.25% repo rate change can lead to major
                    cumulative impact on your loan cost.
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-4">
          <h2 style={headingStyle}>
            How Does the Repo Rate Based EMI Calculator Work?
          </h2>
          <ul style={paragraphStyleOL}>
            <li>
              {" "}
              <strong>Input Loan Details: </strong>Assume repo rate reduction or
              increase (typically ±0.25%).
            </li>
            <li>
              {" "}
              <strong>Recalculate EMI: </strong>New interest rate is calculated
              and applied to find new EMI.
            </li>
            <li>
              {" "}
              <strong>Display Impact: </strong>
              <ul style={paragraphStyleUL}>
                <li>New EMI amount</li>
                <li>Monthly savings (if rates fall) OR</li>
                <li>Monthly increase (if rates rise)</li>
              </ul>
            </li>
          </ul>
          <h6
            style={{
              fontSize: "18px",
              lineHeight: "20px",
            }}
          >
            Formula Used
          </h6>
          <ul style={paragraphStyleUL}>
            <li> EMI = P × r × (1 + r)^n / ((1 + r)^n – 1)</li>
          </ul>
          <h6
            style={{
              fontSize: "18px",
              lineHeight: "20px",
            }}
          >
            Where:
          </h6>
          <ul style={paragraphStyleUL}>
            <li> P = Principal (Loan Amount)</li>
            <li> r = Monthly Interest Rate (Annual Interest ÷ 12)</li>
            <li> n = Total Loan Tenure in Months</li>
          </ul>
          <p style={paragraphStyle}>
            New Interest Rate = Current Interest Rate ± Repo Rate Impact
          </p>
        </section>
        <section>
          <h2 style={headingStyle}>
            When Should You Use the Repo Rate Based EMI Calculator?
          </h2>
          <h6
            style={{
              fontSize: "18px",
              lineHeight: "20px",
            }}
          >
            Use it whenever:
          </h6>
          <ul style={paragraphStyleUL}>
            <li> RBI announces a repo rate change</li>
            <li> Your bank updates its lending rates</li>
            <li>
              {" "}
              You are evaluating refinancing, prepayment, or balance transfer
            </li>
            <li>
              You want to plan future EMI payments based on macro-economic
              forecasts
            </li>
          </ul>
          <p style={paragraphStyle}>Stay ahead whether rates rise or fall!</p>
          <h2 style={headingStyle}>Example Calculations</h2>
          <h6
            style={{
              fontSize: "18px",
              lineHeight: "20px",
              // color: "#26292b",
            }}
          >
            Example 1: Repo Rate Decrease by 0.25%
          </h6>
          <ul style={paragraphStyleUL}>
            <li> Loan Amount: ₹20,00,000</li>
            <li> Current Interest Rate: 9%</li>
            <li>Tenure: 20 years</li>
          </ul>

          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>Current EMI:</span> ₹17,995
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>
              After 0.25% Reduction (8.75%):
            </span>{" "}
            ₹17,551
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>Monthly Savings:</span> ₹444
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>
              Total Savings Over 20 Years:
            </span>{" "}
            ₹1,06,560
          </p>
          <h6
            style={{
              fontSize: "18px",
              lineHeight: "20px",
            }}
          >
            Example 2: Repo Rate Increase by 0.25%
          </h6>
          <ul style={paragraphStyleUL}>
            <li> Loan Amount: ₹10,00,000</li>
            <li> Current Interest Rate: 10%</li>
            <li>Tenure: 5 years</li>
          </ul>

          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>Current EMI:</span> ₹21,247
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>
              After 0.25% Increase (10.25%):
            </span>{" "}
            ₹21,420
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>Monthly Increase:</span> ₹173
          </p>
          <p style={paragraphStyle}>
            <span style={{ fontWeight: 600 }}>
              Total Additional Outflow Over 5 Years:
            </span>{" "}
            ₹10,380
          </p>
        </section>
        <section>
          <h2 style={headingStyle}>Expert Opinion</h2>
          <div className="perspective_box d-flex flex-column gap-3 p-4 mt-3 rounded-2">
            <div className="perspective_content d-flex flex-column  justify-content-center align-items-center ps-3 py-0 ">
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  // color: "#ffffff",
                  color: "#000",
                  fontWeight: 500,
                  fontFamily: "'Archivo', sans-serif",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    // color: "#fff",
                    color: "#000",
                  }}
                  className="archivo"
                >
                  "
                </span>
                Repo rate changes have a profound impact on floating-rate loans.
                Borrowers should regularly monitor RBI announcements and use
                tools like the Repo Rate Based EMI Calculator to stay informed,
                negotiate better deals, or refinance when conditions are
                favorable.
                <span
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    // color: "#fff",
                    color: "#000",
                  }}
                  className="archivo"
                >
                  "
                </span>
              </Typography>
            </div>
            <div className=" d-flex flex-row flex-md-column align-items-center align-items-md-end">
              <Typography
                sx={{
                  fontSize: "13px",
                  lineHeight: "20px",
                  fontWeight: 500,
                  // color: "#fff",
                  color: "#000",
                  fontFamily: "'Archivo',sans-serif",
                }}
                className=" mt-md-3 ps-3"
              >
                MinEMI Credit Research Team
              </Typography>
            </div>
          </div>
        </section>
        <section className="mt-4">
          <h2 style={headingStyle}>
            Check Your Credit Profile Before Refinancing
          </h2>
          <ul style={paragraphStyleUL}>
            <li>
              Check your eligibility for balance transfer or refinancing at
              better rates.
            </li>
            <li>
              <Link to={"/credit-score"}>Check Your Credit Score Now</Link> —
              Instant, safe, and no impact on score.
            </li>
          </ul>
          <h2 style={headingStyle}>Disclaimer</h2>
          <p style={paragraphStyle}>
            This calculator provides an estimated EMI based on an assumed direct
            linkage between repo rate changes and lending rates. Actual EMI
            changes may vary depending on your lender's policies, timing of rate
            revisions, and other factors. Please consult your bank or financial
            advisor for precise information.
          </p>
        </section>
      </div>
    </>
  );
};

export default StepOne;
